import { memo, useEffect, useState } from "react";
import { Box, BoxProps, Flex, usePrevious, keyframes } from "@chakra-ui/react";

export const FadeInOut = memo(({ value = "" }: { value?: string }) => {
  const [currentValue, setCurrentValue] = useState(value);
  const previousValue = usePrevious(currentValue);

  useEffect(() => {
    setCurrentValue(value);
  }, [value]);

  return (
    <Flex {...RootStyles(value)}>
      <Box key={`${previousValue}-previous`} {...PreviousStyles}>
        {previousValue}
      </Box>
      <Box key={`${currentValue}-current`} {...CurrentStyles}>
        {currentValue}
      </Box>
    </Flex>
  );
});

const RootStyles = (value: string): BoxProps => ({
  position: "relative",
  flexDir: "column",
  overflow: "hidden",
  minW: value === ":" ? "0.4em" : "0.7em",
  lineHeight: value === ":" ? "1.2em" : undefined,
});

const ValueStyles: BoxProps = {
  position: "relative",
  top: 0,
  left: 0,
  right: 0,
  textAlign: "center",
};

const popOut = keyframes`
  0% {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
  100% {
    transform: translateY(-1.25em) scale(0.8);
    opacity: 0;
  }
`;

const PreviousStyles: BoxProps = {
  ...ValueStyles,
  position: "absolute",
  css: {
    animation: `${popOut} 1s 1`,
    animationFillMode: "forwards",
  },
};

const popIn = keyframes`
  0% {
    transform: translateY(1.25em) scale(0.8);
    opacity: 0;
  }
  100% {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
`;

const CurrentStyles: BoxProps = {
  ...ValueStyles,
  css: {
    animation: `${popIn} 1s 1`,
    animationFillMode: "forwards",
  },
};
